module.exports = __webpack_public_path__ + "img/check_approved.3cf4c84d.svg";